<template>
    <div class="main-product">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="{ product } in exhibitions" :key="product._id" class="swiper-slide">
                    <router-link class="product-list" :to="`/shop/products/${product._id}`">
                        <span class="product-list__thumb">
                            <span class="product-list__thumbnail">
                                <span :data-background="product.thumb" class="swiper-lazy product-list__thumbnail-image"></span>
                            </span>
                            <span class="product-list__thumb-image"></span>
                            <div class="swiper-lazy-preloader"></div>
                        </span>
                        <span class="product-list__brand">{{ (product.store || {}).nickname }}</span>
                        <span class="product-list__title">{{ product.name }}</span>
                        <span class="product-list__price">
                            <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.discountRate }}%</span>
                            <em class="product-list__price-num">{{ product.salePrice.format() }}원</em>
                            <span v-if="product.discountEnabled" class="product-list__price-line">{{ product.price.format() }}</span>
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="main-product__pagination"></div>
        <div class="main-product__prev"></div>
        <div class="main-product__next"></div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    props: {
        code: { type: String, default: null },
    },
    data() {
        return {
            filter: {
                code: this.$props.code,
            },
            // 더미 슬라이드
            lists: new Array(40),

            exhibitions: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { exhibitions } = await api.v1.shop.exhibitions.getExhibitions({ params: this.filter });
                this.exhibitions = exhibitions;

                this.render();
                this.$emit("load", exhibitions);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        render: function() {
            this.$nextTick(() => {
                var slideProductBest = new Swiper(".main-section--best .swiper-container", {
                    allowTouchMove: false,
                    spaceBetween: 30,
                    speed: 400,
                    loop: false,
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    slidesPerColumn: 2,
                    watchSlidesVisibility: true,
                    preloadImages: false,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 1,
                    },
                    navigation: {
                        nextEl: ".main-section--best .main-product__next",
                        prevEl: ".main-section--best .main-product__prev",
                    },
                    breakpoints: {
                        500: {
                            allowTouchMove: true,
                            spaceBetween: 10,
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            slidesPerColumn: 1,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 1,
                            },
                        },
                        768: {
                            allowTouchMove: true,
                            spaceBetween: 10,
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 1,
                            },
                        },
                        1024: {
                            allowTouchMove: true,
                            spaceBetween: 10,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 1,
                            },
                        },
                    },
                });
            });
        },
    },
};
</script>
